import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import * as tslib_1 from "tslib";
import classNames from "classnames";
import React from "react";
import { forwardRefAs, Generic } from "../../base";
import { FieldBody } from "./field-body";
import { FieldLabel } from "./field-label";
export var FIELD_DEFAULTS = {
  alignments: ["centered", "right"],
  kinds: ["addons", "group"]
};
export var Field = Object.assign(forwardRefAs(function (props, ref) {
  var _classNames;

  var align = props.align,
      expanded = props.expanded,
      horizontal = props.horizontal,
      kind = props.kind,
      multiline = props.multiline,
      narrow = props.narrow,
      rest = tslib_1.__rest(props, ["align", "expanded", "horizontal", "kind", "multiline", "narrow"]);

  var k;

  if (kind === "addons") {
    k = "has-addons";
  } else if (kind === "group") {
    k = "is-grouped";
  }

  rest.className = classNames("field", (_classNames = {}, _defineProperty(_classNames, "".concat(k), k), _defineProperty(_classNames, "".concat(k, "-").concat(align), k !== undefined && align !== undefined), _defineProperty(_classNames, "".concat(k, "-multiline"), k === "is-grouped" && multiline === true), _defineProperty(_classNames, "is-expanded", expanded), _defineProperty(_classNames, "is-horizontal", horizontal), _defineProperty(_classNames, "is-narrow", narrow), _classNames), rest.className);
  return React.createElement(Generic, Object.assign({
    ref: ref
  }, rest));
}, {
  as: "div"
}), {
  Body: FieldBody,
  Label: FieldLabel
});
Field.displayName = "Field";